module.exports = __webpack_public_path__ + "img/48.4976c2f4.png";